//import momentTime from "moment-timezone";
import { LOGIN_ROOT } from '../service/apiUrls';
import { authTokenCookie } from '../utils/CookieMaker';
import store from '../redux/store/index';
import { setAPIMKey } from '../component/Screens/employeeDiscount/employeeDiscountForm/employeeDiscountFormAction';
export const logout = () => {
  sessionStorage.clear();
  let { userInfo} = authTokenCookie();
  sessionStorage.setItem("sessionId", userInfo.userId)
  clearRedux('logout');
  document.cookie.split(";").map(cookies => {
    document.cookie = cookies.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    return cookies;
});
  window.location.replace(`${LOGIN_ROOT}/azurelogout`);
}

export const serverlogout = () => {
  sessionStorage.clear();
  let { userInfo} = authTokenCookie();
  sessionStorage.setItem("sessionId", userInfo.userId)
  clearRedux('logout');
  window.location.replace(`${LOGIN_ROOT}/loginError`);
}
export const clearRedux =(checkLogout)=>{
  let state=store.getState();
  if(checkLogout !== 'logout'){
   const key=state.empDiscount.key;
   store.dispatch(setAPIMKey(key));
  }
  else {
    localStorage.clear();
  }
}



export const getUserID = () => {
  let { userInfo } = authTokenCookie();
  return userInfo.userId;
};


export const phoneNumberFormatter = (phone) => {
  if (phone) {
    let phnNum = phone.toString()
    return `(${phnNum.slice(0, 3)})-${phnNum.slice(3, 6)}-${phnNum.slice(6)}`;
  }
}

export const hasWhiteSpace = (val) => {
  return /^\s|\s$/.test(val);
}
